declare global {
  interface Window {
    __isPremiumUser?: boolean;
  }
}

const isPremiumClient = (): boolean =>
  typeof window !== 'undefined' && window.__isPremiumUser === true;

export const NextOptiDigitalAdArea = ({ areaId }: { areaId: string }) => {
  if (isPremiumClient()) {
    return null;
  }
  return (
    <div style={{ display: 'flex', width: '100%' }}>
      <div style={{ display: 'none' }} className={areaId} />
    </div>
  );
};
